import { http } from '@/core/helpers/axiosHelper';
import { FileUrl } from '@/core/models/file-url.interface';
import { LocationQuery } from 'vue-router';

export class DocumentUrlService {
   async getDocumentUrls(employeeId: number, query?: LocationQuery) {
      const response = await http.get<Array<FileUrl>>(`/employees/${employeeId}/document-urls`, { params: { ...query } });
      return response.data;
   }

   async getDocumentUrl() {
      throw Error('Method not implemented');
   }

   async postDocumentUrl() {
      throw Error('Method not implemented');
   }

   async putDocumentUrl() {
      throw Error('Method not implemented');
   }

   async deleteDocumentUrl() {
      throw Error('Method not implemented');
   }
}
